import apiService from '../apiService'

export const TipAndTutorialController = configService => {
  const service = apiService(configService)

  return {
    getVdoEnglistAuction: type => {
      return service.get({
        url: `cms/supplier/tutorial?type=${type}`,
      })
    },
    downloadGuideFile: (type, lang) => {
      return service.downloadFile({
        url: `cms/supplier/tutorial/pdf?type=${type}&lang=${lang}`,
      })
    },
  }
}
